const logs = {
    page_title: 'Registos de auditoria',
    title: 'Registos de auditoria',
    subtitle: 'Visualize logs de autenticação feitos por administradores e utilizadores',
    event: 'Evento',
    user: 'Utilizador',
    application: 'Aplicação',
    time: 'Hora',
    filter_by: 'Filtrar pors',
    last_1_hour: 'Última hora',
    last_24_hours: 'Últimas 24 horas',
    last_7_days: 'Últimos 7 dias',
    last_30_days: 'Últimos 30 dias',
    custom_range: 'Intervalo personalizado',
    from: 'De',
    to: 'Até',
};
export default Object.freeze(logs);
